import { ReactNode } from "react";
import styled from "styled-components";

import {
  CollapsibleContainer,
  CollapsibleContainerBody,
  CollapsibleContainerHeader,
} from "@vfuk/core-collapsible-container";
import Container from "@vfuk/core-container";

const RowCellsContainer = styled.div`
  width: 100%;
  display: grid;
  grid-auto-flow: column;
  margin-left: 30px;
  box-sizing: border-box;
  word-wrap: break-word;
  word-break: break-word;
  grid-column-gap: 1.1rem;
  grid-template-columns: repeat(auto-fit, minmax(7rem, 1fr));

  /* If the screen is less than 1280px in width, reduce gap  to save some space */
  @media (max-width: 1280px) {
    grid-column-gap: 0.05rem;
    align-items: center;
    grid-template-columns: repeat(auto-fit, minmax(5.6rem, 1fr));
  }
`;

const RowCellsBody = styled.div`
  background-color: #ebebeb;
  padding: 15px 30px;
  margin-top: 5px;
`;

const TableCollapsibleRowContainer = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
`;

type Props = {
  rowCells: ReactNode[];
  collapsibleRowBody: ReactNode;
  isOpen: boolean;
  onToggle?: (isOpen: boolean) => void;
};

export const TableCollapsibleRow = ({
  rowCells,
  isOpen,
  collapsibleRowBody,
  onToggle,
}: Props) => {
  return (
    <TableCollapsibleRowContainer>
      <CollapsibleContainer isActive={isOpen} onToggle={onToggle}>
        <Container elevation paddingLevel={2} allowOverflow={true} zIndex={0}>
          <CollapsibleContainerHeader>
            <RowCellsContainer>{rowCells}</RowCellsContainer>
          </CollapsibleContainerHeader>
        </Container>
        <CollapsibleContainerBody>
          <RowCellsBody>{collapsibleRowBody}</RowCellsBody>
        </CollapsibleContainerBody>
      </CollapsibleContainer>
    </TableCollapsibleRowContainer>
  );
};
